module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/experiences/spaces/SPACES_01.png";